import type { RestangularService } from '../common/restangular.service'

import { app } from '../../app.module'

export interface IUserData {
  userId: number
  username: string
  pictureUrl: string
}

/**
 * 宛先指定用のコンポーネント
 * @class DestinationUserListComponentCtrl
 */
class DestinationUserListComponentCtrl {
  private groupId: string
  private userList: IUserData[]
  private toUsers: IUserData[]
  private disabled: boolean

  constructor(
    $rootScope,
    private RestangularService: RestangularService
  ) {
    this.groupId = $rootScope.groupId
  }

  /**
   * 初期化
   */
  public $onInit(): void {
    // グループのユーザーリストを取得
    const endpoint = `group/users?group_id=${this.groupId}`

    this.RestangularService.request('GET', endpoint, null).then((result) => {
      this.userList = result[0].data
    })
  }

  /**
   * バインディング変数が変更される時の処理
   */
  public $onChanges(): void {
    if (this.disabled === true) {
      this.toUsers = []
    }
  }

  /**
   * 宛先を入力する時の処理
   * @param {string} searchUser 入力したユーザー
   * @return {array} フィルタリング結果
   */
  public queryUserSearch(searchUser: string): IUserData[] {
    if (this.userList === undefined) {
      return null
    }
    // 指定出来る宛先リストをセット
    const selectUserList = this.setSelectUserList()
    const users = searchUser
      ? selectUserList.filter(this.createFilterFor(searchUser))
      : selectUserList

    this.setSuggestionBoxHeight(users)

    return users
  }

  /**
   * フィルタリングの作成
   * @param {string} searchUser クエリ
   * @return {object} フィルタリスト
   */
  public createFilterFor(searchUser: string) {
    searchUser = searchUser.toLowerCase()

    return function filterFn(item) {
      return item.name.indexOf(searchUser) === 0
    }
  }

  /**
   * 指定出来る宛先リストをセット
   * @return {array} 宛先リスト
   */
  private setSelectUserList() {
    // 既に指定された宛先がない場合
    if (this.toUsers === undefined || this.toUsers.length === 0) {
      return this.userList
    }

    return this.userList.filter((user) => {
      return this.toUsers.indexOf(user) === -1
    })
  }

  // サジェストポップアップの高さが0になるのを防ぐ
  private setSuggestionBoxHeight(list) {
    const suggestionContainers = document.querySelectorAll(
      'md-virtual-repeat-container.md-autocomplete-suggestions-container'
    )

    if (suggestionContainers && suggestionContainers.length) {
      for (let i = 0; i < suggestionContainers.length; i++) {
        const element = suggestionContainers[i] as HTMLElement
        element.style.height = `${list.length * 50}px`
      }
    }
  }
}

app.component('destinationUserList', {
  bindings: {
    toUsers: '=',
    disabled: '<',
  },
  template: require('./destination-user-list.pug')(),
  controller: DestinationUserListComponentCtrl,
})
